import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => ({
    newStep: null,
    editingPPStepId: null,
    editingPMStepId: null,
    newEditingQuestionId: null,
    editingPPQuestionId: null,
    editingPMQuestionId: null,
    editingQuestion: null,
    newAction: null,
    editingAnswerId: null,
    editingPPActionId: null,
    editingPMActionId: null,
    newEditingConditionId: null,
    editingPPConditionId: null,
    editingPMConditionId: null,
    editingCondition: null,
});

const customTunnelSlice = createSlice({
    name: 'customTunnel',
    initialState: getInitialState(),
    reducers: {
        editingStepIdSet(state, action) {
            if (!action.payload) {
                state.editingPPStepId = null;
                state.editingPMStepId = null;
            } else {
                state.editingPPStepId = action.payload.ppId;
                state.editingPMStepId = action.payload.pmId;
            }
        },
        editingQuestionIdSet(state, action) {
            if (!action.payload) {
                state.editingPPQuestionId = null;
                state.editingPMQuestionId = null;
            } else {
                state.editingPPQuestionId = action.payload.ppId;
                state.editingPMQuestionId = action.payload.pmId;
            }
        },
        editingQuestionSet(state, action) {
            if (action.payload) {
                const { key, value } = action.payload;
                if (key) {
                    state.editingQuestion[key] = value;
                } else {
                    state.editingQuestion = value;
                }
            } else {
                state.editingQuestion = null;
                if (state.newStep) {
                    state.newStep.questions = state.newStep.questions.filter(q => q.title);
                }
            }
        },
        editingQuestionAnswerAdded(state, action) {
            state.editingQuestion.answers = [...state.editingQuestion.answers, action.payload];
        },
        editingQuestionAnswerUpdated(state, action) {
            const { value, answerIndex } = action.payload;
            let newAnswers = [...state.editingQuestion.answers];
            newAnswers.splice(answerIndex, 1, value);
            state.editingQuestion.answers = newAnswers;
        },
        editingQuestionAnswerRemoved(state, action) {
            const { answerIndex } = action.payload;
            let newAnswers = [...state.editingQuestion.answers];
            newAnswers.splice(answerIndex, 1);
            state.editingQuestion.answers = newAnswers;
        },
        editingAnswerIdSet(state, action) {
            state.editingAnswerId = action.payload;
            if (!action.payload && state.editingQuestion) {
                // ckear empty answers
                state.editingQuestion.answers = state.editingQuestion.answers.filter(q => q.title);
            }
        },
        editingActionIdSet(state, action) {
            if (!action.payload) {
                state.editingPPActionId = null;
                state.editingPMActionId = null;
            } else {
                state.editingPPActionId = action.payload.ppId;
                state.editingPMActionId = action.payload.pmId;
            }
        },
        newStepSet(state, action) {
            state.newStep = action.payload;
        },
        newEditingQuestionIdSet(state, action) {
            state.newEditingQuestionId = action.payload;
        },
        newStepUpdated(state, action) {
            const { key, value } = action.payload;
            state.newStep[key] = value;
        },
        newStepQuestionAdded(state, action) {
            state.newStep.questions = [...state.newStep.questions, action.payload];
        },
        newStepQuestionUpdated(state, action) {
            const { key, value, questionIndex } = action.payload;
            if (key) {
                state.newStep.questions[questionIndex][key] = value;
            } else {
                state.newStep.questions[questionIndex] = value;
            }
        },
        newStepQuestionRemoved(state, action) {
            const { questionIndex } = action.payload;
            let newQuestions = [...state.newStep.questions];
            newQuestions.splice(questionIndex, 1);
            state.newStep.questions = newQuestions;
        },
        newActionSet(state, action) {
            state.newAction = action.payload;
        },
        newActionUpdated(state, action) {
            const { key, value } = action.payload;
            state.newAction[key] = value;
        },
        newActionConditionAdded(state, action) {
            state.newAction.conditions = [...state.newAction.conditions, action.payload];
        },
        newActionConditionUpdated(state, action) {
            const { key, value, conditionIndex } = action.payload;
            if (key) {
                state.newAction.conditions[conditionIndex][key] = value;
            } else {
                state.newAction.conditions[conditionIndex] = value;
            }
        },
        newActionConditionRemoved(state, action) {
            const { conditionIndex } = action.payload;
            let newConditions = [...state.newAction.conditions];
            newConditions.splice(conditionIndex, 1);
            state.newAction.conditions = newConditions;
        },
        newEditingConditionIdSet(state, action) {
            state.newEditingConditionId = action.payload;
        },
        editingConditionIdSet(state, action) {
            if (!action.payload) {
                state.editingPPConditionId = null;
                state.editingPMConditionId = null;
            } else {
                state.editingPPConditionId = action.payload.ppId;
                state.editingPMConditionId = action.payload.pmId;
            }
        },
        editingConditionSet(state, action) {
            if (action.payload) {
                const { key, value } = action.payload;
                if (key) {
                    state.editingCondition[key] = value;
                } else {
                    state.editingCondition = value;
                }
            } else {
                state.editingCondition = null;
                if (state.newAction) {
                    state.newAction.conditions = state.newAction.conditions.filter(
                        q => q.limitValue
                    );
                }
            }
        },
        customTunnelReducerCleared(state, action) {
            for (let key of Object.keys(state)) {
                state[key] = null;
            }
        },
    },
});

export const {
    editingStepIdSet,
    editingQuestionIdSet,
    editingAnswerIdSet,
    editingActionIdSet,
    newEditingQuestionIdSet,
    newStepSet,
    newStepUpdated,
    newStepQuestionAdded,
    newStepQuestionUpdated,
    editingQuestionSet,
    editingQuestionAnswerAdded,
    editingQuestionAnswerUpdated,
    editingQuestionAnswerRemoved,
    newStepQuestionRemoved,
    newActionSet,
    newActionUpdated,
    newActionConditionAdded,
    newActionConditionUpdated,
    newActionConditionRemoved,
    editingConditionIdSet,
    editingConditionSet,
    newEditingConditionIdSet,
    customTunnelReducerCleared,
} = customTunnelSlice.actions;

export const selectors = {
    getEditingStepId: state => ({
        ppId: state.customTunnel.editingPPStepId,
        pmId: state.customTunnel.editingPMStepId,
    }),
    getEditingQuestionId: state => ({
        ppId: state.customTunnel.editingPPQuestionId || null,
        pmId: state.customTunnel.editingPMQuestionId || null,
    }),
    getEditingConditionId: state => ({
        ppId: state.customTunnel.editingPPConditionId || null,
        pmId: state.customTunnel.editingPMConditionId || null,
    }),
    getNewEditingQuestionId: state => state.customTunnel.newEditingQuestionId,
    getNewEditingConditionId: state => state.customTunnel.newEditingConditionId,
    getEditingQuestion: state => state.customTunnel.editingQuestion,
    getEditingAnswerId: state => state.customTunnel.editingAnswerId,
    getEditingActionId: state => ({
        ppId: state.customTunnel.editingPPActionId || null,
        pmId: state.customTunnel.editingPMActionId || null,
    }),
    getNewStep: state => state.customTunnel.newStep,
    getNewAction: state => state.customTunnel.newAction,
    getEditingCondition: state => state.customTunnel.editingCondition,
};

export default customTunnelSlice.reducer;
